import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Transition } from "@headlessui/react";
import {
  editProfile,
  fetchUserProfile,
  getBankList,
  getCountryList,
  getNonNigerianBanksList,
  updatebBank,
  updateSocial,
} from "../../../api-client/profile";
import { useCookies } from "react-cookie";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { DashCard } from "../card";
import Input, { EditInput } from "../input";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import * as cookie from "cookie";
import * as setCookie from "set-cookie-parser";
import axios from "axios";
import Cookie from "universal-cookie";
import CountryModalBank, {
  AddBankModal,
  CountryModal,
  NonNigerianBankModal,
} from "../../widgets/modals/select-modal";
import Button from "../button";
import countriesData from "../../sections/profile/Country.json";
import PaymentForm from "./New_sidebar";
import { authClient, axiosInstance } from "../../../api-client";
import PageLoader from "../../widgets/page-loader";

const BankSidebar = ({ country }) => {
  const [open, setOpen] = useState(false);

  const [cookie, setCookie] = useCookies();
  // const [_banks, setBanks] = useState([]);
  const [_mobileMoney, setMobileMoney] = useState([]);

  const { data: _countryList, isCountryLoading } = useQuery(
    ["country-list"],
    getCountryList
  );
  const [buttonText, setButtonText] = useState("Update Bank");
  const [isBankDetailsUpdated, setIsBankDetailsUpdated] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [showAccountNameInput, setShowAccountNameInput] = useState(false);
  const [selectCountryModal, setSelectCountryModal] = useState(false);
  const [selectedBank, setSelectedBank] = useState("");
  const [momoOptions, setMomoOptions] = useState([]);
  const [memoOptions, setMemoOptions] = useState([]);
  const [selectedMomoNetwork, setSelectedMomoNetwork] = useState("");
  const [momoPhoneNumber, setMomoPhoneNumber] = useState("");
  const [cryptoToken, setCryptoToken] = useState("");
  const [momoNetwork, setMomoNetwork] = useState("");
  // const [bankBranch, setBankBranch] = useState("");
  const [apiResponse, setApiResponse] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("");
  // const [paymentOptions, setPaymentOptions] = useState([]);
  // const [selectedBank, setSelectedBank] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [banks, setBanks] = useState([]);
  const [branches, setBranches] = useState([]);

  const [paymentOptions, setPaymentOptions] = useState([]);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("");

  const [countryValue, setCountryValue] = useState("");
  // input State
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [phone2, setPhone2] = useState("");
  const [countrys, setCountrys] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [paymentInstruction, setPaymentInstruction] = useState("");

  const [bankName, setBankName] = useState("");
  const [accountName, setAccountName] = useState("");
  const [momoName, setMomoName] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [accountNameLoading, setAccountNameLoading] = useState(false);
  const [error, setError] = useState("");

  // const [loading, setLoading] = useState(false);
  const [wiseEmail, setWiseValue] = useState("");
  // const [cryptoAddress, setCryptoValue] = useState("");
  // const [cryptoAddress, setCryptoValue] = useState("");
  const [cryptoAddress, setCryptoAddress] = useState("");
  const [paypalEmail, setPaypalValue] = useState("");
  const [momoValue, setMomoValue] = useState("");
  const [refreshTimer, setRefreshTimer] = useState(null); // State for managing the refresh timer
  const [selectedBankName, setSelectedBankName] = useState("");
  const [selectedBranchName, setSelectedBranchName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  // const [country, setCountry] = useState("NG");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    let timer = null;

    if (loading) {
      // Start a timer for 3 seconds to trigger refresh
      timer = setTimeout(() => {
        window.location.reload();
      }, 3000); // 3000 milliseconds = 3 seconds
      setRefreshTimer(timer); // Save the timer ID in state
    } else {
      // Clear the timer if loading stops
      clearTimeout(refreshTimer);
    }

    return () => clearTimeout(timer); // Cleanup on unmount or when loading stops
  }, [loading]); // Re-run effect when loading state changes

  const countryList = useMemo(
    () =>
      _countryList?.data?.data.map((val) => ({
        label: val.name,
        value: val.code,
      })),
    [_countryList]
  );

  const handleFetchError = (error) => {
    if (error.response) {
      const { status, data } = error.response;
      if (status === 401) {
        handleSessionExpired();
      } else {
        handleErrorMessages(status, data.message);
      }
    } else if (error.request) {
      toast.error(
        "Network Error: Please check your internet connection and try again."
      );
    } else {
      toast.error("Error: " + error.message);
    }
  };

  const handleSessionExpired = () => {
    cookie.remove("authToken", { path: "/" });
    cookie.remove("user", { path: "/" });
    cookie.remove("userId", { path: "/" });
    toast.error("Your session has expired. Please login again.");
    window.location.href = "/auth/sign-in";
  };

  const handleErrorMessages = (status, message) => {
    const errorMessages = {
      400: "Bad Request: Invalid request data.",
      403: "Forbidden: You do not have permission to access this resource.",
      404: "Not Found: The requested product could not be found.",
      500: "Server Error: Please try again later.",
    };
    toast.error(
      message ||
        errorMessages[status] ||
        "An error occurred while fetching the product details."
    );
  };

  useEffect(() => {
    console.log("Momo Options updated:", momoOptions);
  }, [momoOptions]);
  const handleSelectPaymentOption = async (paymentOption) => {
    setSelectedPaymentOption(paymentOption);

    const selectedOption = paymentOptions.find(
      (option) => option.code === paymentOption
    );

    if (selectedOption?.type && selectedOption.type.startsWith("bank")) {
      await fetchBanksByPaymentOption(paymentOption);
    }

    if (paymentOption.startsWith("wise")) {
      setPaymentInstruction("Enter your Wise email");
    } else if (paymentOption.startsWith("crypto")) {
      setPaymentInstruction("Choose your USDT address");
    } else if (paymentOption.startsWith("paypal")) {
      setPaymentInstruction("Enter your PayPal Email");
    } else if (paymentOption.startsWith("momo")) {
      setPaymentInstruction("Enter your Momo phone number");
    } else {
      setPaymentInstruction("");
    }
  };

  const [bankDetails, setBankDetails] = useState(null);

  const [paymentOption, setPaymentOption] = useState(null);

  useEffect(() => {
    const fetchUserBank = async () => {
      const cookies = new Cookie();
      const authToken = cookies.get("authToken");
      const BASE_URL =
        process.env.NEXT_PUBLIC_API_URL || "https://xxx.stakecut.com/api/";

      const axiosInstance = axios.create({
        baseURL: BASE_URL,
        timeout: 60000,
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${authToken}`,
        },
      });

      createAuthRefreshInterceptor(axiosInstance, async (failedRequest) => {
        try {
          const response = await axiosInstance.get("/api/refreshToken");
          const { accessToken } = response.data;

          // Update tokens
          cookies.set("authToken", accessToken, { path: "/" });
          const bearer = `Bearer ${accessToken}`;
          axiosInstance.defaults.headers.authorization = bearer;

          const responseCookie = setCookie.parse(
            response.headers["set-cookie"]
          )[0];
          axiosInstance.defaults.headers.cookie = cookie.serialize(
            responseCookie.name,
            responseCookie.value
          );
          failedRequest.response.config.headers.authorization = bearer;

          return Promise.resolve();
        } catch (error) {
          console.error("Error refreshing token:", error);
          return Promise.reject(error);
        }
      });

      try {
        const res = await axiosInstance.get("profile/getbank-details");
        const data = res.data.data; // Accessing the data object directly
        setBankDetails(data); // Set the entire data object
        setPaymentOption(data.paymentOption); // Set paymentOption from the data object
      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.log("Unauthorized access - returning empty string.");
          // Handle unauthorized access gracefully without logging the user out
          setBankDetails(null); // Clear bank details
          setPaymentOption(null); // Clear payment option
        } else {
          console.error("Error fetching bank details:", error);
        }
      }
    };

    fetchUserBank();
  }, []);
  const isEmpty = (value) => value === "" || value === null || value === 0;

  const hasAnyDetail = (details) => {
    if (!details || typeof details !== "object") {
      return false; // Return false if details is null, undefined, or not an object
    }

    return Object.values(details).some((value) => !isEmpty(value));
  };

  const hasDetails = hasAnyDetail(bankDetails);


  const renderContentBasedOnPaymentOption = () => {
    if (!paymentOption) {
      // Handle the case where paymentOption is null or undefined
      return (
        <div className="w-full">
          <div className="bg-[#f4f5f7] rounded-[20px] p-5 lg:h-[98px] h-full flex flex-col text-left w-full">
            <div className="lg:px-10 px-3 mt-2">
              <p className="font-[500] text-[14px] leading-[16px] text-[#828282] py-2">
                You don’t have any account number
              </p>
              <p className="text-[10px] font-[400]">
                Link your bank account number to your Stakecut account
              </p>
            </div>
          </div>
        </div>
      );
    }

    switch (true) {
      case paymentOption === "wise":
        return (
          <div className="flex flex-wrap bg-[#f4f5f7] rounded-[20px] gap-y-3 p-3 lg:px-12 px-3 my-10 items-center w-full">
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">Wise Email</h4>
                <h3 className="text-[15px] font-[600] text-[#282828] leading-[24px]">
                  {bankDetails.wiseEmail}
                </h3>
              </div>
            </section>
          </div>
        );
      case paymentOption === "paypal":
        return (
          <div className="flex flex-wrap bg-[#f4f5f7] rounded-[20px] gap-y-3 p-3 lg:px-12 px-3 my-10 items-center w-full">
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">
                  PayPal Email
                </h4>
                <h3 className="text-[15px] font-[600] text-[#282828] leading-[24px]">
                  {bankDetails.paypalEmail}
                </h3>
              </div>
            </section>
          </div>
        );
      case paymentOption === "crypto":
        return (
          <div className="flex flex-wrap bg-[#f4f5f7] rounded-[20px] gap-y-3 p-3 lg:px-12 px-5 my-10 items-center w-full">
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">
                  Crypto Adress
                </h4>
                <h3 className="text-[15px] font-[600] text-[#282828] leading-[24px]">
                  {bankDetails.cryptoAddress}
                </h3>
              </div>
            </section>
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">
                  Crypto Token
                </h4>
                <h3 className="text-[15px] font-[600] text-[#282828] leading-[24px]">
                  {bankDetails.cryptoToken}
                </h3>
              </div>
            </section>
          </div>
        );
      case paymentOption.startsWith("momo"):
        return (
          <div className="flex flex-wrap bg-[#f4f5f7] rounded-[20px] gap-y-3 p-3 lg:px-12 px-5 my-10 items-center w-full">
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">
                  Momo Network:
                </h4>
                <h3 className="text-[15px] font-[600] text-[#282828] leading-[24px]">
                  {bankDetails.momoNetwork}
                </h3>
              </div>
            </section>
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">
                  Momo Phone Number:
                </h4>
                <h3 className="text-[15px] font-[600] text-[#282828] leading-[24px]">
                  {bankDetails.momoPhoneNumber}
                </h3>
              </div>
            </section>
          </div>
        );
      case paymentOption.startsWith("bank") && paymentOption !== "bankBranch":
        return (
          <div className="flex flex-wrap bg-[#f4f5f7] rounded-[20px] gap-y-3 p-3 lg:px-12 px-5 my-10 items-center w-full">
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">Bank Name</h4>
                <h3 className="text-[15px] font-[600] text-[#282828] leading-[24px]">
                  {bankDetails.bankName}
                </h3>
              </div>
            </section>

            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] font-[400] leading-[14px] mb-2">
                  Account Number
                </h4>
                <p className="text-[15px] font-[600] leading-[24px] text-[#282828]">
                  {bankDetails.accountNumber}
                </p>
              </div>
            </section>
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">
                  Account Name
                </h4>
                <p className="text-[15px] font-[600] leading-[24px] text-[#282828]">
                  {bankDetails.accountName}
                </p>
              </div>
            </section>
          </div>
        );
      case paymentOption === "bankBranch":
        return (
          <div className="flex flex-wrap bg-[#f4f5f7] rounded-[20px] gap-y-3 p-3 lg:px-12 px-5 my-10 items-center w-full">
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] font-[400] leading-[14px] mb-2">
                  Account Number
                </h4>
                <p className="text-[15px] font-[600] leading-[24px] text-[#282828]">
                  {bankDetails.accountNumber}
                </p>
              </div>
            </section>
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between mb-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">
                  Account Name
                </h4>
                <p className="text-[15px] font-[600] leading-[24px] text-[#282828]">
                  {bankDetails.accountName}
                </p>
              </div>
            </section>

            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">Bank Branch</h4>
                <h3 className="text-[15px] font-[600] text-[#282828] leading-[24px]">
                  {bankDetails.bankBranch}
                </h3>
              </div>
            </section>
            <section className="flex items-center lg:w-1/4 md:w-1/2 w-full justify-between my-5">
              <div>
                <h4 className="text-[#828282] text-[12px] mb-2">Bank Name</h4>
                <h3 className="text-[15px] font-[600] text-[#282828] leading-[24px]">
                  {bankDetails.bankName}
                </h3>
              </div>
            </section>
          </div>
        );
      default:
        return (
          <div>
            {/* Render default content if no payment option matches */}
            <p>No payment option selected.</p>
          </div>
        );
    }
  };

  const updateProfile = async () => {
    setLoading(true);

    const data = {
      firstName,
      lastName,
      phone,
      phone2,
      country: selectedCountry,
    };

    try {
      const res = await editProfile(data);
      setLoading(false);

      setPhoneFocus(false);
      setPhone2Focus(false);
      setSelectCountryModal(false);

      setFirstName(res?.data?.data?.firstName);
      setLastName(res?.data?.data?.lastName);
      setPhone(res?.data?.data?.phone);
      setPhone2(res?.data?.data?.phone2);
      setCountrys(res?.data?.data?.country);

      toast.success(res.data.message);
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.message);
    }
  };

  const handleEnterDetails = () => {
    if (!selectedCountry) {
      toast.error("Please select a country first");
      return;
    }
  };

  // Example function to fetch banks by payment option
  const fetchBanksByPaymentOption = async (paymentOption) => {
    const cookies = new Cookie();
    let authToken = cookies.get("authToken");
    const BASE_URL =
      process.env.NEXT_PUBLIC_API_URL || "https://xxx.stakecut.com/api/";

    const axiosInstance = axios.create({
      baseURL: BASE_URL,
      timeout: 60000,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${authToken}`,
      },
    });

    // Create the refresh token interceptor
    createAuthRefreshInterceptor(axiosInstance, async (failedRequest) => {
      try {
        const response = await axiosInstance.get("/api/refreshToken");
        const { accessToken } = response.data;

        // Update tokens
        cookies.set("authToken", accessToken, { path: "/" });
        const bearer = `Bearer ${accessToken}`;
        axiosInstance.defaults.headers.authorization = bearer;

        const responseCookie = setCookie.parse(
          response.headers["set-cookie"]
        )[0];
        axiosInstance.defaults.headers.cookie = cookie.serialize(
          responseCookie.name,
          responseCookie.value
        );
        failedRequest.response.config.headers.authorization = bearer;

        return Promise.resolve();
      } catch (error) {
        console.error("Error refreshing token:", error);
        return Promise.reject(error);
      }
    });

    // Check and refresh the token if needed
    if (!authToken) {
      try {
        const response = await axiosInstance.get("/api/refreshToken");
        const { accessToken } = response.data;

        // Update tokens
        cookies.set("authToken", accessToken, { path: "/" });
        authToken = accessToken;
        axiosInstance.defaults.headers.authorization = `Bearer ${authToken}`;
      } catch (error) {
        console.error("Error refreshing token:", error);
        return [];
      }
    }

    try {
      const response = await axiosInstance.get("/profile/banks", {
        params: {
          paymentOption: paymentOption,
        },
      });
      // Handle the response
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          cookie.remove("authToken", { path: "/" });
          cookie.remove("user", { path: "/" });
          cookie.remove("userId", { path: "/" });
          toast.error("Your session has expired. Please login again.");
          window.location.href = "/auth/sign-in";
        } else if (status === 400) {
          toast.error(data.message || "Bad Request: Invalid request data.");
        } else if (status === 403) {
          toast.error(
            "Forbidden: You do not have permission to access this resource."
          );
        } else if (status === 404) {
          toast.error("Not Found: The requested product could not be found.");
        } else if (status === 500) {
          toast.error("Server Error: Please try again later.");
        } else {
          toast.error(
            data.message ||
              "An error occurred while fetching the product details."
          );
        }
      } else if (error.request) {
        toast.error(
          "Network Error: Please check your internet connection and try again."
        );
      } else {
        toast.error("Error: " + error.message);
      }
      // reject(error);
    }
  };

  const fetchBankBranches = async (bankCode, branchName) => {
    const cookies = new Cookie();
    let authToken = cookies.get("authToken");
    const BASE_URL =
      process.env.NEXT_PUBLIC_API_URL || "https://xxx.stakecut.com/api/";

    const axiosInstance = axios.create({
      baseURL: BASE_URL,
      timeout: 60000,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${authToken}`,
      },
    });

    // Create the refresh token interceptor
    createAuthRefreshInterceptor(axiosInstance, async (failedRequest) => {
      try {
        const response = await axiosInstance.get("/api/refreshToken");
        const { accessToken } = response.data;

        // Update tokens
        cookies.set("authToken", accessToken, { path: "/" });
        const bearer = `Bearer ${accessToken}`;
        axiosInstance.defaults.headers.authorization = bearer;

        const responseCookie = setCookie.parse(
          response.headers["set-cookie"]
        )[0];
        axiosInstance.defaults.headers.cookie = cookie.serialize(
          responseCookie.name,
          responseCookie.value
        );
        failedRequest.response.config.headers.authorization = bearer;

        return Promise.resolve();
      } catch (error) {
        console.error("Error refreshing token:", error);
        return Promise.reject(error);
      }
    });

    // Check and refresh the token if needed
    if (!authToken) {
      try {
        const response = await axiosInstance.get("/api/refreshToken");
        const { accessToken } = response.data;

        // Update tokens
        cookies.set("authToken", accessToken, { path: "/" });
        authToken = accessToken;
        axiosInstance.defaults.headers.authorization = `Bearer ${authToken}`;
      } catch (error) {
        console.error("Error refreshing token:", error);
        return [];
      }
    }
    setSelectedBranchName(branchName);
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/payment/bank-branch/${bankCode}`
      );
      setBranchName(branchName); // Store the branchName
      return { data: response.data.data, branchName };
    } catch (error) {
      handleFetchError(error);
      throw error; // Rethrow the error to handle it in the calling function
    } finally {
      setLoading(false);
    }
  };

  const handleSelectBank = async (bankCode, bankName, bankId) => {
    setLoading(true); // Start loading
    setSelectedBank(bankCode);
    setSelectedBankName(bankName); // Set the bank name
    console.log("Selected Bank Code:", bankCode);
    console.log("Selected Bank Name:", bankName);
    console.log("Selected Bank ID:", bankId);
    try {
      if (selectedPaymentOption === "bankBranch") {
        // Fetch branches of the selected bank and set branch information
        const res = await fetchBankBranches(bankId, bankName);
        setBranches(res.data);
        console.log("whole content", res.data);
      } else {
        // Reset branches or perform other actions specific to 'bank' option
        setBranches([]); // Reset branches when not 'bankBranch'
      }
    } catch (error) {
      handleFetchError(error);
    } finally {
      setLoading(false); // End loading
    }
  };

  const handleEnterDetailss = () => {
    if (!selectedBank || !selectedBranch || !accountNumber || !accountName) {
      toast.error("Please fill in all the details");
      return;
    }
  };
  const handleFetchAccountName = async () => {
    if (accountNumber.length > 0 && selectedBank) {
      setIsLoading(true);
      setError("");
      const cookies = new Cookie();
      let authToken = cookies.get("authToken");
      const BASE_URL =
        process.env.NEXT_PUBLIC_API_URL || "https://xxx.stakecut.com/api/";

      const axiosInstance = axios.create({
        baseURL: BASE_URL,
        timeout: 60000,
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${authToken}`,
        },
      });

      // Create the refresh token interceptor
      createAuthRefreshInterceptor(axiosInstance, async (failedRequest) => {
        try {
          const response = await axiosInstance.get("/api/refreshToken");
          const { accessToken } = response.data;

          // Update tokens
          cookies.set("authToken", accessToken, { path: "/" });
          const bearer = `Bearer ${accessToken}`;
          axiosInstance.defaults.headers.authorization = bearer;

          const responseCookie = setCookie.parse(
            response.headers["set-cookie"]
          )[0];
          axiosInstance.defaults.headers.cookie = cookie.serialize(
            responseCookie.name,
            responseCookie.value
          );
          failedRequest.response.config.headers.authorization = bearer;

          return Promise.resolve();
        } catch (error) {
          console.error("Error refreshing token:", error);
          return Promise.reject(error);
        }
      });

      // Check and refresh the token if needed
      if (!authToken) {
        try {
          const response = await axiosInstance.get("/api/refreshToken");
          const { accessToken } = response.data;

          // Update tokens
          cookies.set("authToken", accessToken, { path: "/" });
          authToken = accessToken;
          axiosInstance.defaults.headers.authorization = `Bearer ${authToken}`;
        } catch (error) {
          console.error("Error refreshing token:", error);
          return [];
        }
      }
      try {
        const requestBody = {
          bankCode: selectedBank,
          accountNumber: accountNumber,
        };

        const response = await axiosInstance.post(
          "/profile/verify-bank-details",
          requestBody
        );

        setAccountName(response.data.data.accountName || "");
        setApiResponse(response.data); // Store the entire API response data
        setIsBankDetailsUpdated(true); // Set flag to true
        setError("");
      } catch (error) {
        setError("Error fetching account name. Please try again.");
        setAccountName("");
        setApiResponse(null);
        setIsBankDetailsUpdated(false); // Reset flag
      } finally {
        setIsLoading(false);
        setButtonText("Submit");
      }
    } else {
      setAccountName("");
      setError("");
      setApiResponse(null);
      setIsBankDetailsUpdated(false); // Reset flag
    }
  };

  const handleSubmit = async () => {
    const cookies = new Cookie();
    let authToken = cookies.get("authToken");
    const BASE_URL =
      process.env.NEXT_PUBLIC_API_URL || "https://xxx.stakecut.com/api/";

    const axiosInstance = axios.create({
      baseURL: BASE_URL,
      timeout: 60000,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${authToken}`,
      },
    });

    // Create the refresh token interceptor
    createAuthRefreshInterceptor(axiosInstance, async (failedRequest) => {
      try {
        const response = await axiosInstance.get("/api/refreshToken");
        const { accessToken } = response.data;

        // Update tokens
        cookies.set("authToken", accessToken, { path: "/" });
        const bearer = `Bearer ${accessToken}`;
        axiosInstance.defaults.headers.authorization = bearer;

        const responseCookie = setCookie.parse(
          response.headers["set-cookie"]
        )[0];
        axiosInstance.defaults.headers.cookie = cookie.serialize(
          responseCookie.name,
          responseCookie.value
        );
        failedRequest.response.config.headers.authorization = bearer;

        return Promise.resolve();
      } catch (error) {
        console.error("Error refreshing token:", error);
        return Promise.reject(error);
      }
    });

    // Check and refresh the token if needed
    if (!authToken) {
      try {
        const response = await axiosInstance.get("/api/refreshToken");
        const { accessToken } = response.data;

        // Update tokens
        cookies.set("authToken", accessToken, { path: "/" });
        authToken = accessToken;
        axiosInstance.defaults.headers.authorization = `Bearer ${authToken}`;
      } catch (error) {
        console.error("Error refreshing token:", error);
        return [];
      }
    }
    if (!accountName && selectedPaymentOption.startsWith("bank")) {
      setError("Account name is required. Please verify your bank details.");
      return;
    }

    const bankDetails = {
      country: selectedCountry,
      bankCode: selectedBank,
      bankBranch: branchName,
      accountName,
      bankBranchCode: selectedBranch,
      accountNumber,
      paymentOption: selectedPaymentOption,
      momoPhoneNumber,
      momoNetwork: selectedMomoNetwork,
      momoName: selectedPaymentOption,
      bankName: selectedBankName,
    };

    if (!selectedPaymentOption) {
      toast.error("Payment option is required");
      console.log("Payment option is required");
      return;
    }

    switch (selectedPaymentOption) {
      case "wise":
        bankDetails.wiseEmail = wiseEmail;
        break;
      case "crypto":
        bankDetails.cryptoAddress = cryptoToken; // Default to "usdt" if not set
        bankDetails.cryptoToken = cryptoAddress || "USDT-TRC20";
        break;
      case "paypal":
        bankDetails.paypalEmail = paypalEmail;
        break;
      case "momo":
        bankDetails.momoValue = momoValue;
        bankDetails.momoNetwork = selectedMomoNetwork;
        bankDetails.momoPhoneNumber = momoPhoneNumber;
        bankDetails.momoName = momoName;
        break;
      default:
        break;
    }

    const dataToSubmit = { ...bankDetails };

    console.log("Selected Payment Option:", selectedPaymentOption);
    console.log("Data to submit:", dataToSubmit);

    try {
      const response = await axiosInstance.post(
        "profile/bank-detail",
        dataToSubmit
      );
      toast.success("Bank details updated successfully");

      // Optionally reload the page after submission
      setTimeout(() => {
        window.location.reload();
      }, 2000); // Adjust the delay as needed
    } catch (error) {
      handleSubmissionError(error);
    }
  };

  const handleButtonClick = async () => {
    if (selectedPaymentOption.startsWith("bank")) {
      if (buttonText === "Update Bank") {
        setButtonText("Fetching Account Name...");
        setShowAccountNameInput(true);
        await handleFetchAccountName();
      } else {
        handleSubmit();
      }
    } else {
      handleSubmit();
    }
  };

  const handleSubmissionError = (error) => {
    let errorMessage;
    if (error.response) {
      errorMessage =
        error.response.data.message ||
        error.response.data.error ||
        error.response.statusText;
    } else if (error.request) {
      errorMessage = "No response received from the server";
    } else {
      errorMessage = error.message;
    }
    toast.error(`Error updating details: ${errorMessage}`);
    console.log(errorMessage);
  };

  return (
    <>
      <div className="flex w-full ">
        <div className="lg:mt-6 w-full ">
          <div className="flex justify-between w-full ">
            <p className="font-[600] text-[#205363] leading-[22.4px] text-[20px] my-10 lg:px-0 px-4">
              Bank Details
            </p>
          </div>
          <div className="mt-10 py-10 lg:px-10 px-5 rounded-[20px] border-[1px] w-full relative  ">
            <div className="flex items-center justify-between my-10 lg:my-16 w-full   ">
              <div>
                <p className="font-[600] b lg:text-[18px] text-[16px] text-[#282828]">
                  Select Bank Country
                </p>
                <h4 className="text-[#828282] text-[12px] leading-[14px] font-[400] my-2">
                  Select the Country <br className="lg:hidden flex" />
                  your Bank Operates from
                </h4>
              </div>

              <CountryModalBank
                setSelectCountryModal={setSelectCountryModal}
                options={countryList}
                selectedInput={selectedCountry}
                setSelectedInput={setSelectedCountry}
                updateProfile={updateProfile}
                value={countryValue}
                setPaymentOptions={setPaymentOptions}
                setValue={setCountryValue}
                setBanks={setBanks}
                setMemoOptions={setMemoOptions}
              />
            </div>

            <section className="flex items-center justify-between lg:my-16  my-10 w-full ">
              <div>
                <p className="font-[600] leading-[21.6px] lg:text-[18px] text-[16px] text-[#282828]">
                  Bank Details
                </p>
                <h4 className="text-[#828282] text-[12px] leading-[16px] my-2">
                  Provide Your Bank Details
                </h4>
              </div>
              <div onClick={handleEnterDetails} className="">
                <button
                  onClick={() => setOpen(true)}
                  className="lg:w-[180px] w-[120px] px-3 py-5 whitespace-nowrap border-[1px] text-[#828282] leading-[14px] text-[13px] font-[500] rounded-xl border-[#205363]"
                >
                  Enter Details
                </button>
              </div>
            </section>

            <div>
              {hasAnyDetail ? (
                renderContentBasedOnPaymentOption()
              ) : (
                <div className="w-full">
                  <div className="bg-[#f4f5f7] rounded-[20px] p-5 lg:h-[98px] h-full flex flex-col text-left w-full">
                    <div className="lg:px-10 px-3 mt-2">
                      <p className="font-[500] text-[14px] leading-[16px] text-[#828282] py-2">
                        You don’t have any account number
                      </p>
                      <p className="text-[10px] font-[400]">
                        Link your bank account number to your Stakecut account
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div>
          <Transition
            show={open}
            enter="transition-opacity ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-in duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            className="fixed inset-0  overflow-hidden z-[0]"
          >
            <div className="absolute inset-0 bg-[#205363] bg-opacity-75 transition-opacity"></div>
          </Transition>
          <section className="absolute inset-y-0  right-0 lg:pl-10 max-w-full flex h-[100vh]">
            <Transition
              show={open}
              enter="transition-transform ease-out duration-300"
              enterFrom="transform translate-x-full"
              enterTo="transform translate-x-0"
              leave="transition-transform ease-in duration-300"
              leaveFrom="transform translate-x-0"
              leaveTo="transform translate-x-full"
              // className="w-screen max-w-xl rounded-l-[24px]   "
              className="w-screen  max-w-2xl lg:max-w-2xl  lg:m-7 m-2 lg:mr-9 mr-1 relative"
            >
              <div
                className=" flex flex-col lg:px-10  py-6 bg-white rounded-[24px] p-4 lg:p-5 relative   "
                style={{ height: "95vh" }}
              >
                {/* flex flex-col py-6 bg-white rounded-[24px] p-2 lg:p-5 */}
                {/* Sidebar Header */}
                <div className="flex items-center justify-between   m-3 pt-8 pb-10 border-b-[1px] ">
                  <div className="flex  flex-col">
                    <h2 className="lg:text-[22px] text-[12px] text-[#205363] font-[600] ">
                      Enter Bank Details
                    </h2>
                    <h2 className="text-[12px] text-[#828282] leading-[16px]  ">
                      Link your bank account number
                      <br className="lg:hidden flex" /> to your stakecut account
                    </h2>
                  </div>
                  <button
                    onClick={() => setOpen(false)}
                    className="text-[#205363] flex items-center border-[1px] border-[#205363] rounded-[10px] py-3 px-3 w-[89px] h-[40px]"
                  >
                    <span className=" text-[#205363] text-[12px] leading-[16.8px] mx-2">
                      Close
                    </span>
                    <svg
                      className="h-[16px] w-[16px] border-[1px] border-[#205363] rounded-full"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
                <div>
                  <div>
                    {loading ? (
                      <div className="flex justify-center items-center">
                        <p className="font-[500] text-[14px] text-[#282828]">
                          Loading branches...
                        </p>
                      </div>
                    ) : (
                      <>
                        {Array.isArray(paymentOptions) &&
                          paymentOptions.length > 0 && (
                            <div className="mt-4">
                              <p className="font-[500] text-[14px] text-[#828282] my-3">
                                Payment Options
                              </p>
                              <select
                                value={selectedPaymentOption}
                                onChange={(e) =>
                                  handleSelectPaymentOption(e.target.value)
                                }
                                className="mt-2 h-[56px] border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] bg-white py-3 w-[100%]"
                                style={{ padding: "12px 12px" }}
                              >
                                <option value="">
                                  Choose a payment option
                                </option>
                                {paymentOptions.map((option) => (
                                  <option
                                    key={option.code}
                                    value={option.code}
                                    className="border-2 py-5"
                                    onMouseEnter={(e) =>
                                      (e.target.style.backgroundColor =
                                        "lightgreen")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.backgroundColor = "white")
                                    }
                                    style={{
                                      paddingTop: "25px",
                                      marginTop: "10px",
                                      color: "#000", // Ensure text color is black
                                    }}
                                  >
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                      </>
                    )}

                    {selectedPaymentOption.startsWith("wise") ||
                    selectedPaymentOption.startsWith("crypto") ||
                    selectedPaymentOption.startsWith("paypal") ? (
                      <div className="mt-4">
                        <p className="font-[500] text-[14px] text-[#828282] my-3">
                          {paymentInstruction}
                        </p>
                        {selectedPaymentOption.startsWith("crypto") ? (
                          <>
                            <select
                              value={cryptoAddress || "USDT-TRC20"} // Set default value
                              onChange={(e) => setCryptoValue(e.target.value)}
                              className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-[100%]"
                            >
                              <option value="usdt">USDT TRC20 address</option>
                            </select>
                            <p className="font-[500] text-[14px] text-[#828282] my-3">
                              Enter USDT address
                            </p>
                            <input
                              type="text"
                              placeholder="Enter USDT address"
                              value={cryptoToken}
                              onChange={(e) => setCryptoToken(e.target.value)}
                              className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-[100%]"
                            />
                          </>
                        ) : (
                          <input
                            type="email"
                            value={
                              selectedPaymentOption.startsWith("wise")
                                ? wiseEmail
                                : selectedPaymentOption.startsWith("crypto")
                                ? cryptoAddress
                                : selectedPaymentOption.startsWith("paypal")
                                ? paypalEmail
                                : accountNumber
                            }
                            onChange={(e) => {
                              if (selectedPaymentOption.startsWith("wise")) {
                                setWiseValue(e.target.value);
                              } else if (
                                selectedPaymentOption.startsWith("crypto")
                              ) {
                                setCryptoValue(e.target.value);
                              } else if (
                                selectedPaymentOption.startsWith("paypal")
                              ) {
                                setPaypalValue(e.target.value);
                              } else {
                                setAccountNumber(e.target.value);
                              }
                            }}
                            placeholder={
                              selectedPaymentOption.startsWith("wise") ||
                              selectedPaymentOption.startsWith("paypal")
                                ? "Enter email address"
                                : "Enter account number"
                            }
                            className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-[100%]"
                          />
                        )}
                      </div>
                    ) : null}

                    {!loading && paymentOptions.length === 0 && (
                      <div className="mt-4">
                        <p className="font-[500] text-[14px] text-[#828282]">
                          Please refresh the page or check your internet
                          connection.
                        </p>
                      </div>
                    )}
                    <div>
                      {selectedPaymentOption.startsWith("momo") &&
                        memoOptions.length > 0 && (
                          <div className="mt-4">
                            <p className="font-[500] text-[14px] text-[#828282] my-3">
                              Select Momo Network
                            </p>
                            <select
                              value={selectedMomoNetwork}
                              onChange={(e) =>
                                setSelectedMomoNetwork(e.target.value)
                              }
                              className="mt-2 h-[56px] border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] bg-white py-3 w-[100%]"
                              style={{ padding: "12px 12px", color: "#000" }}
                            >
                              <option value="">Choose a Momo network</option>
                              {memoOptions.map((option) => (
                                <option
                                  key={option.code}
                                  value={option.code}
                                  style={{ color: "#000" }} // Ensure text color is black
                                >
                                  {option}
                                </option>
                              ))}
                            </select>

                            <div className="mt-4">
                              <p className="font-[500] text-[14px] text-[#828282] my-3">
                                Enter your Momo phone number
                              </p>
                              <input
                                type="number"
                                placeholder="Momo phone number"
                                value={momoPhoneNumber}
                                onChange={(e) =>
                                  setMomoPhoneNumber(e.target.value)
                                }
                                className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-[100%]"
                              />
                            </div>
                          </div>
                        )}
                    </div>
                    <div></div>

                    <div>
                      {selectedPaymentOption.startsWith("bank") &&
                        selectedPaymentOption !== "bankBranch" &&
                        selectedPaymentOption !== "bankWithAddress" && (
                          <>
                            {banks && banks.length > 0 ? (
                              <section className="flex flex-col justify-between lg:my-5 my-3 w-full">
                                <div className="w-full">
                                  <p className="font-[500] text-[14px] text-[#828282] my-3">
                                    Choose bank
                                  </p>
                                  <select
                                    value={selectedBank}
                                    onChange={(e) => {
                                      const selectedBankCode = e.target.value;
                                      const selectedBank = banks.find(
                                        (bank) => bank.code === selectedBankCode
                                      );

                                      handleSelectBank(
                                        selectedBankCode,
                                        selectedBank ? selectedBank.name : "",
                                        selectedBank ? selectedBank.id : ""
                                      );
                                    }}
                                    className="mt-2 border-[1px] rounded-[8px] outline-none px-5 h-[56px] border-[#B3BAC5] bg-white py-3 w-full"
                                    style={{ width: "100%" }}
                                  >
                                    <option value="">Select a bank</option>
                                    {banks.map((bank) => (
                                      <option key={bank.id} value={bank.code}>
                                        {bank.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div className="mt-4">
                                  <p className="font-[500] text-[14px] text-[#828282] my-3">
                                    Account Number
                                  </p>
                                  <input
                                    type="text"
                                    value={accountNumber}
                                    onChange={(e) =>
                                      setAccountNumber(e.target.value)
                                    }
                                    className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-[100%]"
                                  />
                                  {isLoading && <p>Loading...</p>}
                                  {error && (
                                    <p className="text-red-500">{error}</p>
                                  )}
                                </div>

                                {showAccountNameInput && (
                                  <div>
                                    {isLoading ? null : accountName ? (
                                      <>
                                        <p className="font-[500] text-[14px] text-[#828282] mt-4">
                                          Account Name
                                        </p>
                                        <input
                                          type="text"
                                          value={accountName}
                                          onChange={(e) =>
                                            setAccountName(e.target.value)
                                          } // Make input editable
                                          className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-[100%]"
                                        />
                                      </>
                                    ) : (
                                      <p className="text-red-500">
                                        Sorry, we couldn&apos;t fetch your
                                        account name. Please refresh and try
                                        again.
                                      </p>
                                    )}
                                  </div>
                                )}
                              </section>
                            ) : (
                              <div className="my-5">
                                <p className="text-red-500">
                                  Sorry, it&apos;s on us. The network is bad.
                                  Can you refresh?
                                </p>
                              </div>
                            )}
                          </>
                        )}
                      {selectedPaymentOption === "bankWithAddress" && (
                        <>
                          {banks && banks.length > 0 ? (
                            <section className="flex flex-col justify-between lg:my-5 my-3 w-full">
                              <div className="w-full">
                                <p className="font-[500] text-[14px] text-[#828282] my-3">
                                  Choose bank
                                </p>
                                <select
                                  value={selectedBank}
                                  onChange={(e) => {
                                    const selectedBankCode = e.target.value;
                                    const selectedBank = banks.find(
                                      (bank) => bank.code === selectedBankCode
                                    );

                                    handleSelectBank(
                                      selectedBankCode,
                                      selectedBank ? selectedBank.name : "",
                                      selectedBank ? selectedBank.id : ""
                                    );
                                  }}
                                  className="mt-2 border-[1px] rounded-[8px] outline-none px-5 h-[56px] border-[#B3BAC5] bg-white py-3 w-full"
                                  style={{ width: "100%" }}
                                >
                                  <option value="">Select a bank</option>
                                  {banks.map((bank) => (
                                    <option key={bank.id} value={bank.code}>
                                      {bank.name}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="mt-4">
                                <div>
                                  <p className="font-[500] text-[14px] text-[#828282] my-3">
                                    Account Name
                                  </p>
                                  <input
                                    type="text"
                                    value={accountName}
                                    onChange={(e) =>
                                      setAccountName(e.target.value)
                                    }
                                    className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-[100%]"
                                  />
                                </div>
                                <div className="mt-4">
                                  <p className="font-[500] text-[14px] text-[#828282] my-3">
                                    Account Number
                                  </p>
                                  <input
                                    type="text"
                                    value={accountNumber}
                                    onChange={(e) =>
                                      setAccountNumber(e.target.value)
                                    }
                                    className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-[100%]"
                                  />
                                </div>
                              </div>
                            </section>
                          ) : (
                            <div className="my-5">
                              <p className="text-red-500">
                                Sorry, it&apos;s on us. The network is bad. Can
                                you refresh?
                              </p>
                            </div>
                          )}
                        </>
                      )}

                      {selectedPaymentOption === "bankBranch" && (
                        <>
                          {banks && banks.length > 0 ? (
                            <section className="flex flex-col justify-between lg:my-5 my-3 w-full">
                              <section className="flex items-center justify-between lg:my-3 my-3 w-full">
                                <div className="w-full">
                                  <p className="font-[500] text-[14px] text-[#828282] my-3">
                                    Choose bank
                                  </p>
                                  <select
                                    value={selectedBank}
                                    onChange={(e) => {
                                      const selectedBankCode = e.target.value;
                                      console.log(
                                        "Selected Bank Code:",
                                        selectedBankCode
                                      );

                                      const selectedBank = banks.find(
                                        (bank) => bank.code === selectedBankCode
                                      );

                                      // Log the selectedBank object
                                      console.log(
                                        "Selected Bank Object:",
                                        selectedBank
                                      );

                                      const selectedBankName = selectedBank
                                        ? selectedBank.name
                                        : "";
                                      const selectedBankId = selectedBank
                                        ? selectedBank.id
                                        : null;
                                      console.log(
                                        "Selected Bank Name:",
                                        selectedBankName
                                      );
                                      console.log(
                                        "Selected Bank ID:",
                                        selectedBankId
                                      );

                                      setSelectedBank(selectedBankCode);
                                      setSelectedBankName(selectedBankName);

                                      handleSelectBank(
                                        selectedBankCode,
                                        selectedBankName,
                                        selectedBankId
                                      );
                                    }}
                                    className="mt-2 border-[1px] rounded-[8px] h-[56px] outline-none px-5 border-[#B3BAC5] bg-white py-3 w-full"
                                  >
                                    <option value="">Select a bank</option>
                                    {banks.map((bank) => (
                                      <option key={bank.id} value={bank.code}>
                                        {bank.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </section>
                            </section>
                          ) : (
                            <div className="my-5">
                              <p className="text-red-500">
                                Sorry, it&apos;s on us. The network is bad. Can
                                you refresh?
                              </p>
                            </div>
                          )}

                          {loading ? (
                            <div className="flex justify-center items-center">
                              <p className="font-[500] text-[14px] text-[#282828]">
                                Loading branches...
                              </p>
                            </div>
                          ) : (
                            branches.length > 0 && (
                              <section className="flex flex-col justify-between lg:my-3 my-3 w-full">
                                <div className="w-full">
                                  <p className="font-[500] text-[14px] text-[#828282] my-3">
                                    Choose branch
                                  </p>
                                  <select
                                    value={selectedBranch}
                                    onChange={(e) => {
                                      const selectedBranchCode = e.target.value;
                                      const selectedBranch = branches.find(
                                        (branch) =>
                                          branch.branch_code ===
                                          selectedBranchCode
                                      );
                                      setSelectedBranch(selectedBranchCode);
                                      setBranchName(
                                        selectedBranch?.branch_name || ""
                                      ); // Set the branch name
                                    }}
                                    className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-full"
                                  >
                                    <option value="">Select a branch</option>
                                    {branches.map((branch) => (
                                      <option
                                        key={branch.branch_code}
                                        value={branch.branch_code}
                                      >
                                        {branch.branch_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </section>
                            )
                          )}

                          <div className="mt-4">
                            <div>
                              <p className="font-[500] text-[14px] text-[#828282] my-3">
                                Account Name
                              </p>
                              <input
                                type="text"
                                value={accountName}
                                onChange={(e) => setAccountName(e.target.value)}
                                className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-[100%]"
                              />
                            </div>
                            <div className="mt-4">
                              <p className="font-[500] text-[14px] text-[#828282] my-3">
                                Account Number
                              </p>
                              <input
                                type="text"
                                value={accountNumber}
                                onChange={(e) =>
                                  setAccountNumber(e.target.value)
                                }
                                className="mt-2 border-[1px] rounded-[8px] outline-none px-5 border-[#B3BAC5] h-[56px] bg-white py-3 w-[100%]"
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <hr />
                  <div className=" mb-10 absolute bottom-2 right-3   pt-7   ">
                    <button
                      className="w-[161px] rounded-[8px] py-[13px] bg-primary-p300 text-light"
                      onClick={handleButtonClick}
                    >
                      {selectedPaymentOption.startsWith("bank") &&
                      selectedPaymentOption !== "bankBranch" &&
                      selectedPaymentOption !== "bankWithAddress" &&
                      !isBankDetailsUpdated
                        ? "Update Bank"
                        : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </Transition>
          </section>
        </div>
      </div>
    </>
  );
};

export default BankSidebar;
